<template>
    <transition name="fade" mode="out-in">
        <section class="padding-vertical-content lightgray-content" key="paso3" id="paso3">
            <div class="container">
                <div class="row">
                    <ContentOrLoading>
                        <div class="col-12" v-if="!loading">
                            <DatosCompradoresComponent 
                                :datos_compradores="datos_comprador"
                                v-on:terminar="guardarDatos" 
                                :solicitar_datos="false" 
                                :asientos="asientos" 
                                :loading="loading"
                                :desactivar="continuarConCompra"
                            ></DatosCompradoresComponent>
                        </div>
                    </ContentOrLoading>
                </div>
            </div>
        </section>
    </transition>
</template>

<script>
import DatosCompradoresComponent from '@/components/frontend/events/compra/DatosCompradoresComponent';

export default {
    props: {
        pack: {
            required: true,
            type: Object
        },
        asientos: {
            type: Array,
            required: true
        },
        session_id: {
            required: true,
            type: String
        },
        continuarConCompra: {
            required: true,
            type: Boolean
        }
    },
    data() {
        return {
            datos_comprador: {},
            loading: false
        }
    },
    mounted() {
        this.$scrollTo('#paso3', 100);
    },
    methods: {
        guardarDatos() {
            this.loading = true;
            var params = {
                filters: {
                    tid : this.configuracion.hash_teatro
                },
                slug: this.pack.slug,
                session_id: this.session_id,
                datos_compradores: this.datos_comprador
            }

            this.$store.dispatch(this.config.getVuexAlias("front.packs.show.carritos.guardar-datos"), params).then(res => {
                this.$emit('continuar', this.datos_comprador, res.data.formulario, res.data.jet_id);
                this.loading = false;
            }).catch(error => {
                this.$toast.error(error.response.data.message);
                this.loading = false;
            });
        },
        cambiarAsiento() {

        }
    },
    computed: {
        configuracion() {
            return this.$store.getters.getConfig;
        }
    },
    components: {
        DatosCompradoresComponent
    }
}
</script>